import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { UploadOutlined } from '@ant-design/icons';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { Button, Checkbox, Form, Input, Select, Upload } from 'antd';
import { AboutContent } from 'component/setup_component/ad_group/style';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { ButtonWrap, FormLabel, FormWrap } from 'pages/settings_page/style';
import { TestMailWraper } from 'component/setup_component/emaildelivery/style';
import { ThemedButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import {
  getDomainEmailDelivery,
  getDomainEmailDeliverySettings,
  getDomainGmailDelivery,
  getDomainMicrosoftMailDelivery,
  testDomainGmail,
  testMicrosoftMail,
  testStandardEmail,
  updateDomainMailDelivery,
  uploadDomainGmailFile,
} from 'redux/slices/mailDeliverySlice';
import { InputPatternRule } from 'utils/input_pattern';

export default function DomainEmailDelivery({ ...record }) {
  const dispatch = useDispatch();
  const [emailForm] = Form.useForm();
  const [emailTestForm] = Form.useForm();
  const [apiLoading, setApiLoading] = useState(false);
  const [uploadedfile, setUploadedfile] = useState('');
  const {
    domainEmailDeliveryData,
    domainGmailDeliveryData,
    domainMicrosoftMailDeliveryData,
    getDomainEmailDeliverySettingsData,
    getDomainEmailDeliverySettingsLoading,
  } = useSelector((state) => state.mailDelivery);
  const [selectedProtocol, setSelectedProtocol] = useState(
    getDomainEmailDeliverySettingsData?.protocol ? getDomainEmailDeliverySettingsData.protocol : 1
  );

  const initialValuesEmailForm = {
    fromName: '',
    emailAccount: '',
    authorizationProtocal: selectedProtocol,
    mailServer: '',
    encryption: 'Plain',
    emailPort: '',
    password: '',
    mailPasswordConformation: '',
    requiresAuthentication: false,
    path: uploadedfile,
    clientId: '',
    secret: '',
    status: '',
    tenantId: '',
  };

  useEffect(() => {
    if (getDomainEmailDeliverySettingsData) {
      setSelectedProtocol(getDomainEmailDeliverySettingsData.protocol || 1);
      emailForm.setFieldsValue({
        authorizationProtocal: getDomainEmailDeliverySettingsData.protocol || 1,
      });
    }
  }, [getDomainEmailDeliverySettingsData]);

  useEffect(() => {
    dispatch(getDomainEmailDeliverySettings(record.id));
    dispatch(getDomainEmailDelivery(record.id));
    dispatch(getDomainGmailDelivery(record.id));
    dispatch(getDomainMicrosoftMailDelivery(record.id));
  }, []);

  useEffect(() => {
    if (domainEmailDeliveryData || domainGmailDeliveryData || domainMicrosoftMailDeliveryData) {
      if (selectedProtocol === 1) {
        emailForm.setFieldsValue({
          fromName: domainEmailDeliveryData?.fromName,
          emailAccount: domainEmailDeliveryData?.emailAccount,
          mailServer: domainEmailDeliveryData?.mailServer,
          encryption: domainEmailDeliveryData?.encryption ? domainEmailDeliveryData.encryption : 'Plain',
          emailPort: parseInt(domainEmailDeliveryData?.emailPort),
          password: domainEmailDeliveryData?.password,
          requiresAuthentication: domainEmailDeliveryData?.requiresAuthentication,
        });
      } else if (selectedProtocol === 2) {
        emailForm.setFieldsValue({ fromName: domainGmailDeliveryData?.fromName });
        setUploadedfile(domainGmailDeliveryData?.path);
      } else if (selectedProtocol === 3) {
        emailForm.setFieldsValue({
          fromName: domainMicrosoftMailDeliveryData?.fromName,
          clientId: domainMicrosoftMailDeliveryData?.clientId,
          secret: domainMicrosoftMailDeliveryData?.secret,
          status: domainMicrosoftMailDeliveryData?.status,
          tenantId: domainMicrosoftMailDeliveryData?.tenantId,
          objectId: domainMicrosoftMailDeliveryData?.objectId,
        });
      }
    } else {
      emailForm.setFieldsValue(initialValuesEmailForm);
    }
  }, [domainEmailDeliveryData, domainGmailDeliveryData, domainMicrosoftMailDeliveryData, selectedProtocol]);

  const handleProtocolChange = (value) => {
    setSelectedProtocol(value);
  };

  const handleTestMail = async () => {
    try {
      await emailForm.validateFields();
      await emailTestForm.validateFields();
    } catch (error) {
      return;
    }
    if (selectedProtocol === 2) {
      if (!uploadedfile) {
        SweetSweetAlert({
          text: 'Please upload Credential File.',
          icon: 'error',
          buttonColor: 'red',
        });
        return;
      }
    }

    let value = emailTestForm.getFieldValue();
    value.authorizationProtocal = emailForm.getFieldValue('authorizationProtocal');

    if (selectedProtocol === 1) {
      value = {
        ...value,
        fromName: emailForm.getFieldValue('fromName'),
        emailAccount: emailForm.getFieldValue('emailAccount'),
        mailServer: emailForm.getFieldValue('mailServer'),
        encryption: emailForm.getFieldValue('encryption'),
        emailPort: parseInt(emailForm.getFieldValue('emailPort')),
        password: emailForm.getFieldValue('password'),
        requiresAuthentication: emailForm.getFieldValue('requiresAuthentication'),
      };
    }
    if (selectedProtocol === 2) {
      value = {
        ...value,
        fromName: emailForm.getFieldValue('fromName'),
        path: uploadedfile,
        domainId: record.id,
      };
    }
    if (selectedProtocol === 3) {
      value = {
        ...value,
        objectId: emailForm.getFieldValue('objectId'),
        clientId: emailForm.getFieldValue('clientId'),
        tenantId: emailForm.getFieldValue('tenantId'),
        secret: emailForm.getFieldValue('secret'),
      };
    }
    try {
      setApiLoading(true);
      let response;
      if (selectedProtocol === 1) {
        response = await dispatch(testStandardEmail(value));
      } else if (selectedProtocol === 2) {
        response = await dispatch(testDomainGmail(value));
      } else if (selectedProtocol === 3) {
        response = await dispatch(testMicrosoftMail(value));
      }
      if (response.payload && response.payload.status === 200) {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
      } else {
        SweetSweetAlert({
          text: `Something Wrong! the email can't be sent. Please check your configuration.`,
          icon: 'error',
          buttonColor: 'red',
        });
      }
    } catch (error) {
      SweetSweetAlert({
        text: `Something Wrong! the email can't be sent. Please check your configuration.`,
        icon: 'error',
        buttonColor: 'red',
      });
    } finally {
      setApiLoading(false);
    }
  };
  const handleFileUpload = async (info) => {
    const { file } = info;

    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append('file', file.originFileObj);
    formData.append('domainId', record.id);
    try {
      setApiLoading(true);
      const response = await dispatch(uploadDomainGmailFile(formData));
      if (response.payload.status === 200) {
        SweetSweetAlert({ sweetData: 'File upload success', icon: 'success', buttonColor: 'green' });
        setUploadedfile(file.name);
      } else {
        SweetSweetAlert({ text: 'File upload failed', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'File upload failed', icon: 'error', buttonColor: 'red' });
    } finally {
      setApiLoading(false);
    }
  };
  const beforeFileUpload = (file) => {
    if (file.type !== 'application/json') {
      SweetSweetAlert({
        text: 'Invalid file type. Please upload a JSON File.',
        icon: 'error',
        buttonColor: 'red',
      });
      return Upload.LIST_IGNORE;
    }
    return false;
  };
  const onFinish = async (value) => {
    try {
      await emailForm.validateFields();
    } catch (error) {
      return;
    }
    if (selectedProtocol === 2) {
      if (!uploadedfile) {
        Swal.fire({
          icon: 'info',
          text: 'Please upload the Credential File',
          showConfirmButton: true,
          confirmButtonColor: 'blue',
          width: '400px',
          reverseButtons: true,
          confirmButtonText: 'ok',
          customClass: {
            icon: 'custom-swal-icon',
            title: 'custom-swal-title',
          },
        });
        return;
      }
    }
    const data = {
      domainSMTP: {
        fromName: value.authorizationProtocal === 1 ? value.fromName || '' : '',
        emailAccount: value.emailAccount || '',
        mailServer: value.mailServer || '',
        encryption: value.encryption || '',
        emailPort: parseInt(value.emailPort) || 0,
        password: value.password || '',
        requiresAuthentication: value?.requiresAuthentication || false,
        toName: '',
        domainId: value.authorizationProtocal === 1 ? record.id : 0,
      },
      domainMicrosoftEmail: {
        objectId: value.objectId || '',
        clientId: value.clientId || '',
        tenantId: value.tenantId || '',
        secret: value.secret || '',
        toName: '',
        domainId: value.authorizationProtocal === 3 ? record.id : 0,
      },
      domainGmail: {
        fromName: value.authorizationProtocal === 2 ? value.fromName || '' : '',
        toName: '',
        path: value.authorizationProtocal === 2 ? uploadedfile : '',
        domainId: value.authorizationProtocal === 2 ? record.id : 0,
      },
      domainMailSettings: {
        protocol: value.authorizationProtocal || '',
        domainId: record.id,
      },
    };
    try {
      setApiLoading(true);
      const response = await dispatch(updateDomainMailDelivery(data));
      if (response.payload && response.payload.status === 200) {
        if (value.authorizationProtocal === 1) {
          dispatch(getDomainEmailDelivery(record.id));
        } else if (value.authorizationProtocal === 2) {
          dispatch(getDomainGmailDelivery(record.id));
        } else if (value.authorizationProtocal === 3) {
          dispatch(getDomainMicrosoftMailDelivery(record.id));
        }
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
      } else {
        SweetSweetAlert({ text: response.payload.data, icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setApiLoading(false);
    }
  };
  return (
    <div>
      {apiLoading && <ModalOpenLoader />}
      <div className='maildelivery emaildelivery af-form-wrap af-mail_delivery-domain-settings-form-wrap'>
        {getDomainEmailDeliverySettingsLoading ? (
          <ModalOpenLoader />
        ) : (
          <Form
            className='af-form af-mail_delivery-domain-settings-form'
            form={emailForm}
            onFinish={onFinish}
            initialValues={initialValuesEmailForm}
            name='register'
            size='large'
            scrollToFirstError
          >
            <FormWrap className='af-form-wraper af-mail_delivery-domain-settings-form-wraper'>
              {selectedProtocol !== 3 && (
                <FormLabel
                  className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-from_name'
                  name='fromName'
                  label={selectedProtocol === 2 ? 'User Email Id' : 'From Name'}
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter this Field',
                    },
                    {
                      pattern: InputPatternRule.pattern,
                      message: InputPatternRule.message,
                    },
                  ]}
                >
                  <Input className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_from_name' />
                </FormLabel>
              )}

              <FormLabel
                className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-authorization_protocal'
                name='authorizationProtocal'
                label='Authorization Protocol'
                style={{ marginBottom: selectedProtocol === 2 ? '5px' : '' }}
              >
                <Select
                  className='af-form-select af-mail_delivery-domain-settings-form-select af-mail_delivery-domain-settings-form-select_authorization_protocal'
                  onChange={handleProtocolChange}
                >
                  <Select.Option
                    className='af-form-select-option af-mail_delivery-domain-settings-form-select-option'
                    value={1}
                  >
                    Standard(SMTP)
                  </Select.Option>
                  <Select.Option
                    className='af-form-select-option af-mail_delivery-domain-settings-form-select-option'
                    value={2}
                  >
                    Gmail Account (OAuth 2.0)
                  </Select.Option>
                  <Select.Option
                    className='af-form-select-option af-mail_delivery-domain-settings-form-select-option'
                    value={3}
                  >
                    Office 365 (OAuth 2.0)
                  </Select.Option>
                </Select>
              </FormLabel>

              {selectedProtocol === 1 && (
                <>
                  <FormLabel
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-email_account'
                    name='emailAccount'
                    label='Email Account'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter this Field',
                      },
                      {
                        type: 'email',
                        message: `Please Enter the E-mail`,
                      },
                    ]}
                  >
                    <Input className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_email_acount' />
                  </FormLabel>
                  <FormLabel
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-mail_server'
                    name='mailServer'
                    label='Mail Server'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter this Field',
                      },
                    ]}
                  >
                    <Input className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_mail_server' />
                  </FormLabel>
                  <FormLabel
                    name='encryption'
                    label='Encryption'
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-encryption'
                  >
                    <Select
                      className='af-form-select af-mail_delivery-domain-settings-form-select af-mail_delivery-domain-settings-form-select_emcryption'
                      showSearch
                      placeholder='Select'
                    >
                      <Select.Option
                        className='af-form-select-option af-mail_delivery-domain-settings-form-select-option'
                        value='Plain'
                      >
                        Plain
                      </Select.Option>
                      <Select.Option
                        className='af-form-select-option af-mail_delivery-domain-settings-form-select-option'
                        value='SSL'
                      >
                        SSL
                      </Select.Option>
                      <Select.Option
                        className='af-form-select-option af-mail_delivery-domain-settings-form-select-option'
                        value='TLS'
                      >
                        TLS
                      </Select.Option>
                    </Select>
                  </FormLabel>
                  <FormLabel
                    name='emailPort'
                    label='Email Port'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter this Field',
                      },
                    ]}
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-emailport'
                  >
                    <Input
                      type='number'
                      className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_emailport'
                    />
                  </FormLabel>
                  <FormLabel
                    name='password'
                    label='Mail Password'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter your Password!',
                      },
                    ]}
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-password'
                  >
                    <Input.Password className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_password' />
                  </FormLabel>

                  <FormLabel
                    name='requiresAuthentication'
                    label='Requires Authentication'
                    valuePropName='checked'
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-requires_authentication'
                  >
                    <Checkbox
                      className='af-form-checkbox af-mail_delivery-domain-settings-form-checkbox af-mail_delivery-domain-settings-form-checkbox_requires_authentication'
                      onChange={(e) => emailForm.setFieldsValue({ requiresAuthentication: e.target.checked })}
                    />
                  </FormLabel>
                </>
              )}

              {selectedProtocol === 2 && (
                <>
                  <AboutContent className='gmail_info af-form-mail-delovery-domain-settings-info'>
                    <a
                      href='https://dartinnovations.com/setting-up-gmail-oauth-2la-for-your-web-application/'
                      target='blank'
                      className='mail-delivery-info-link-domain-settings'
                    >
                      Google OAuth Setup?
                    </a>
                  </AboutContent>
                  <FormLabel
                    name='path'
                    label='Service Account JSON'
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-path'
                  >
                    <Upload
                      className='af-form-upload af-mail_delivery-domain-settings-form-upload af-mail_delivery-domain-settings-form-upload_path'
                      onChange={handleFileUpload}
                      showUploadList={false}
                      beforeUpload={beforeFileUpload}
                    >
                      <Button
                        className='af-form-upload-button af-mail_delivery-domain-settings-form-upload-button af-mail_delivery-domain-settings-form-upload-button_path'
                        icon={<UploadOutlined />}
                      >
                        Click to Upload Json
                      </Button>
                    </Upload>
                    {uploadedfile && (
                      <p
                        className='mail-delivery-domain-settings-show-file-list'
                        style={{ marginBottom: '0px', marginLeft: '3px', color: 'red' }}
                      >
                        {uploadedfile}
                      </p>
                    )}
                  </FormLabel>
                </>
              )}

              {selectedProtocol === 3 && (
                <>
                  <FormLabel
                    name='objectId'
                    label='Object ID'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter this Field',
                      },
                    ]}
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-objectid'
                  >
                    <Input className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_objectid' />
                  </FormLabel>
                  <FormLabel
                    name='clientId'
                    label='Client Id'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter this Field',
                      },
                    ]}
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-clientid'
                  >
                    <Input className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_clientid' />
                  </FormLabel>
                  <FormLabel
                    name='tenantId'
                    label='Tenant Id'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter this Field',
                      },
                    ]}
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-tenantid'
                  >
                    <Input className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_tenantid' />
                  </FormLabel>
                  <FormLabel
                    name='secret'
                    label='Secret'
                    rules={[
                      {
                        required: true,
                        message: 'Please Enter this Field',
                      },
                    ]}
                    className='af-form-item af-mail_delivery-domain-settings-form-item af-mail_delivery-domain-settings-form-item-secret'
                  >
                    <Input.Password className='af-form-input af-mail_delivery-domain-settings-form-input af-mail_delivery-domain-settings-form-input_secret' />
                  </FormLabel>
                </>
              )}
              <div>
                <Form
                  className='af-form af-test-mail_delivery-domain-settings-form'
                  form={emailTestForm}
                  initialValues={{
                    toName: '',
                  }}
                  name='register'
                  size='large'
                >
                  <h2 className='test-mail_delivery-domain-settings-title-head'>Test Connection:</h2>
                  <TestMailWraper className='test-mail-delivery-domain-settings-wrapper'>
                    <div className='test-mail-delivery-domain-settings-input-wrapper' style={{ width: '100%' }}>
                      <FormLabel
                        name='toName'
                        label='Email'
                        rules={[
                          {
                            required: true,
                            message: 'Please Enter your Email!',
                          },
                          {
                            type: 'email',
                            message: `Please Enter the E-mail`,
                          },
                        ]}
                        className='af-form-item af-test-mail_delivery-domain-settings-form-item af-test-mail_delivery-domain-settings-form-item-email'
                      >
                        <Input className='af-form-input af-test-mail_delivery-domain-settings-form-input af-test-mail_delivery-domain-settings-form-input_email' />
                      </FormLabel>
                    </div>
                    <div className='test-mail-delivery-domain-settings-button-wrapper' style={{ marginLeft: '20px' }}>
                      <FormLabel
                        className='af-form-item af-test-mail_delivery-domain-settings-form-item af-test-mail_delivery-domain-settings-form-item-submit-button'
                        style={{ textAlign: 'end' }}
                      >
                        <ThemedButton
                          className='test_mail test-mail-domain-settings-submit-button'
                          htmlType='button'
                          onClick={handleTestMail}
                        >
                          Send
                        </ThemedButton>
                      </FormLabel>
                    </div>
                  </TestMailWraper>
                </Form>
              </div>
            </FormWrap>

            <ButtonWrap className='af-form-button-submit-wrapper af-test-mail-domain-settings-form-button-submit-wrapper'>
              <StyledButton
                className='af-form-button af-test-mail-domain-settings-form-button af-test-mail-domain-settings-form-button_submit'
                type='primary'
                htmlType='submit'
              >
                Submit
              </StyledButton>
            </ButtonWrap>
          </Form>
        )}
      </div>
    </div>
  );
}
